const Divider=()=>{
    return(
        <div className="divider">
            <label>or</label>
        </div>
    )
}

export default Divider